import React from "react";
import "./AutumnLeaves.css"; // Create a CSS file for stylingimport
import "./Test.scss"; // Create a CSS file for styling

import { Snowflake } from "../../../../assets/holidays/icons";

const AutumnLeaf = ({ style }) => <div className="autumn-leaf" style={style}></div>;
const PumpkinFall = ({ style }) => <div className="pumpkinFall" style={style}></div>;
const BatFall = ({ style }) => <div className="bat-icon" style={style}></div>;
const SnowFall = ({ style }) => <div className="snowFall" style={style}></div>;
const ChristmasLight = ({ style, className }) => (
	<ul className={className}>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
		<li></li>
	</ul>
);
const AutumnLeaves = () => {
	const leafCount = 50; // Number of leaves

	const getRandomInt = (min, max) => {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	};

	const renderLeaves = () => {
		const leaves = [];
		// for (let i = 0; i < leafCount; i++) {
		// 	const style = {
		// 		left: `${getRandomInt(0, 100)}%`,
		// 		animationDuration: `${getRandomInt(0, 40)}s`,
		// 		animationDelay: `${getRandomInt(0, 5)}s`,
		// 	};
		// 	let whichOne = getRandomInt(0, 4);
		// 	if (whichOne === 1 || whichOne === 0 || whichOne === 3) {
		// 		// style.left = `${getRandomInt(75, 100)}%`;
		// 		leaves.push(<SnowFall key={i} style={style} />);
		// 	} else {
		// 		// style.left = `${getRandomInt(0, 35)}%`;
		// 		leaves.push(<SnowFall key={i} style={style} />);

		// 		// leaves.push(<BatFall key={i} style={style} />);
		// 	}
		// }
		return leaves;
	};

	return (
		<>
			{" "}
			{/* <ChristmasLight className={"lightrope up"} /> */}
			{/* <ChristmasLight className={"lightrope down"} />{" "} */}
			{/* <ChristmasLight className={"lightrope left"} />{" "}
			<ChristmasLight className={"lightrope right"} /> */}
			<div className="autumn-leaves-container">{renderLeaves()}</div>
		</>
	);
};

export default AutumnLeaves;
